import * as React from 'react';
import Msg from '../../../localization/Msg';
import { Str } from '../../../localization/translationKeys';
import { css } from '@emotion/core';
import { COLORS } from '../../../globalStyle/colors';
import { Requirement } from '../../models';
import LocalDiv from '../../../localization/LocalDiv';
import { FLEX_ROW } from '../../../layout/flexBox';
import Spacer from '../../../layout/Spacer';
import RequirementMenuItem from '../../requirements/RequirementMenuItem';


const styles = {
  root:          css`
    margin: 18px 0;
    align-items: center;
    color: ${COLORS.DARK_GREY};
  `,
  reqsContainer: css`
    flex-wrap: wrap;
  `,
};


type Props = {
  className?: string;
  minimumsRequired: boolean;
  maximumsRequired: boolean;
  requirements: Requirement[];
};


/**
 * RequirementBar: a component that displays text descriptions of project requirements with simple visual progress cues
 * (e.g., icons and colored text)
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RequirementBar: React.FC<Props> = props => (
  <LocalDiv css={[FLEX_ROW, styles.root]} className={props.className}>
    <Msg str={!!props.requirements ? (props.minimumsRequired ? Str.InviteRequirements : Str.RecommendedMinimums) : ''} />
    <Spacer sizePx={40} />
    <LocalDiv css={[FLEX_ROW, styles.reqsContainer]}>
      {
        props.requirements.map(
          requirement => (
            <RequirementMenuItem
              css={[FLEX_ROW]}
              key={requirement.fullName}
              title={`${requirement.completedCount}/${requirement.minimumRequired}`}
              requirement={requirement}
              showMaximum={props.maximumsRequired}
            />
          ),
        )
      }
    </LocalDiv>
  </LocalDiv>
);

export default RequirementBar;
